<h1 mat-dialog-title *ngIf="title">{{ title }}</h1>


<div mat-dialog-content class="mat-subheading-1" fxLayout>
	<div class="mat-body" fxLayout="column" fxFlex>
    Expected columns:
    <div *ngFor="let col of expectedColumns">
      {{ col }}
    </div>
  </div>

	<div class="mat-body" fxLayout="column" fxFlex>
    Columns in File:
    <div *ngFor="let col of columnsInFile">
      {{ col }}
    </div>
  </div>
</div>


<div mat-dialog-actions>
	<button type="button" mat-button (click)="extraButtonFn" color="accent" *ngIf="extraButton">{{ extraButton }}</button>
	<span class="spacer"></span>
	<button id="id_cancel_btn" type="button" mat-button (click)="dialogRef.close(false)" *ngIf="hasCancel">{{ cancelButton }}</button>
	<button id="id_ok_btn" type="button" mat-button (click)="dialogRef.close(true)" cdkFocusInitial [color]="color" >{{ button }}</button>
</div>